<template>
    <div class="my-3 d-flex flex-column align-items-center justify-content-center">
        <div v-if="user.image">
            <img class="img-avatar img-avatar-thumb" :src="user.image" alt="" />
        </div>
        <div v-else class="client-icon">
            <!-- SVG avatar fallback -->
            <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                <path
                    d="M17.0007 14.1663C20.1303 14.1663 22.6673 11.6293 22.6673 8.49967C22.6673 5.37006 20.1303 2.83301 17.0007 2.83301C13.871 2.83301 11.334 5.37006 11.334 8.49967C11.334 11.6293 13.871 14.1663 17.0007 14.1663Z"
                    fill="#94A3B8"
                />
                <path
                    d="M28.3327 24.792C28.3327 28.3124 28.3327 31.167 16.9993 31.167C5.66602 31.167 5.66602 28.3124 5.66602 24.792C5.66602 21.2716 10.7405 18.417 16.9993 18.417C23.2582 18.417 28.3327 21.2716 28.3327 24.792Z"
                    fill="#94A3B8"
                />
            </svg>
        </div>

        <h1 class="fs-6 poppinsSemiBold text-left pt-3 uppercaseFirstLetter">{{ user.first_name }} {{ user.last_name }}</h1>

        <div class="mt-2 text-center">
            <div class="d-flex flex-row justify-content-center">
                <form :action="routes.updateLoyaltyPoints" method="POST">
                    <input type="hidden" name="_token" :value="csrf" />

                    <span v-if="!editing" id="show_PF" class="d-flex flex-row justify-content-center lh-1 fs-xs">
                        {{ this.$t('form_customer_v2.action_setting.loyalty_points') }} :
                        <p class="mx-1 my-0 fs-xs lh-1">{{ customer.loyalty_points }}</p>
                        <svg
                            @click.prevent="editing = true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="none"
                            viewBox="0 0 16 16"
                        >
                            <path d="..." stroke="#94A3B8" />
                        </svg>
                    </span>

                    <div v-if="editing" id="edit_PF">
                        <div class="row justify-content-end">
                            <div class="col-3 px-0">
                                <input
                                    v-model="customer.loyalty_points"
                                    class="form-control h-32 fs-xs rounded-2"
                                    name="loyalty_points"
                                />
                            </div>
                            <div class="col-6 d-flex justify-content-start">
                                <button type="submit" class="btn h-32 fs-xs btn-dark rounded-2">Enregistrer</button>
                                <button
                                    type="button"
                                    @click="editing = false"
                                    class="h-32 w-32 mx-2 my-0 btn-close p-0 rounded-2 border-solid-1-gs"
                                >
                                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="..." /></svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <p class="fs-xs p-0 fw-light">
                * {{ $t('form_customer_v2.action_setting.either') }} {{ spentInFormatted }}{{ symbolCurrency }}
                {{ $t('form_customer_v2.action_setting.in_your_establishment') }} *
            </p>
            <p class="fs-xs p-0 fw-light">
                * {{ $t('form_customer_v2.action_setting.wallet_balance') }}: {{ walletFormatted }}{{ symbolCurrency }}
                {{ $t('form_customer_v2.action_setting.in_your_establishment') }} *
            </p>
        </div>

        <div class="d-flex justify-content-center w-100 gap-4 mt-2">
            <BaseLink :href="routes.createBooking">{{ $t('form_customer_v2.action_setting.btn_create_booking') }}</BaseLink>

            <BaseLink :href="routes.managePayments">{{
                $t('form_customer_v2.action_setting.btn_payment_subscription_management')
            }}</BaseLink>

            <BaseLink :href="`${routes.quickSale}?customerSelect=${user.id}`">{{
                $t('form_customer_v2.action_setting.btn_quick_sale')
            }}</BaseLink>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="802" height="2" viewBox="0 0 802 2" fill="none">
            <path d="M1 1H801" stroke="#94A3B8" stroke-opacity="0.2" stroke-linecap="round" />
        </svg>
    </div>
</template>
<script>
import BaseLink from '../../Shared/BaseLink.vue'
import BaseButton from '../../Shared/BaseButton.vue'

export default {
    name: 'ActionSection',
    components: { BaseLink, BaseButton },
    props: ['user', 'customer', 'spentIn', 'symbolCurrency', 'csrf', 'walletBalance', 'routes'],
    data() {
        return {
            editing: false,
        }
    },
    computed: {
        spentInFormatted() {
            return this.spentIn.toLocaleString(this.$currencyLocale?.replace('_', '-') || 'fr-FR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
        },
        walletFormatted() {
            return (this.walletBalance / 100).toLocaleString(this.$currencyLocale?.replace('_', '-') || 'fr-FR', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            })
        },
    },
}
</script>

<style scoped>
/* Add your styles here */
</style>
